const mr = {
  //Breadcrumb
  home: "मुखपृष्ठ",
  aboutUs: "आमच्याबद्दल",
  products: "उत्पादने",
  research: "संशोधन",
  infrastructure: "पायाभूत सुविधा",
  network: "नेटवर्क",
  store: "स्टोअर",
  careers: "करिअर्स",
  reachUs: "आमच्याशी संपर्क साधा",
  dashboard: "डॅशबोर्ड",
  cropBook: "पिक पुस्तक",
  search: "खोजें",
  blog: "ब्लॉग",
  cart: "कार्ट",
  login: "लॉगिन",
  privacyPolicy: "गोपनीयता धोरण",
  termOfUse: "वापरण्याच्या अटी",
  disclaimer: "अस्वीकरण",
  cancellationAndRefund: "रद्द करणे आणि परतावा",
  shippingAndDelivery: "शिपिंग आणि वितरण",

  //Menu Page//Menu Page
  OurProducts: "आमची उत्पादने",
  OurProductsDescription: "देशभरातील विविध कृषी-हवामान क्षेत्रांच्या अचूक पीक वाढीच्या गरजा पूर्ण करण्यासाठी संशोधन-समर्थित, उच्च-उत्पादन देणारे बियाणे विकसित केले जातात, ज्यामुळे शेतकऱ्यांना सर्वोत्तम परिणाम मिळतात.",
  // Home Page
  ViewDetailsButton: "तपशील पहा",
  YashodaAtAGlanceHeading: "तपशील पहा",
  ExploreCategoryButton: "श्रेणी एक्सप्लोर करा",
  KnowMoreButton: "अधिक जाणून घ्या", 
  BuyOnlineButton: "ऑनलाइन खरेदी करा",
  NetworkHead: "आमचे संपूर्ण नेटवर्क पाहण्यासाठी, कृपया तुमचा संपर्क क्रमांक शेअर करा.",
  ExploreOurNetworkButton: "आमचे नेटवर्क एक्सप्लोर करा",
  JobOpenings: "नोकरीची संधी",
  TeamStrength: "२००+ संघाची ताकद",
  TeamMembers: "50+ टीम सदस्य 10+ वर्षांपासून आमच्यासोबत काम करत आहेत",
  Experience: "अनुभव",
  ExploreOpportunities: "संधी एक्सप्लोर करा",
  LifeYashoda: "यशोदा सीड्स @ लाईफ",
  FarmersConnectedHead: "शेतकरी जोडले गेले",
  FarmersConnectButton: "शेतकरी कनेक्ट",
  ExploreMoreButton: "अधिक एक्सप्लोर करा",

  //about us
  YearExperience: "वर्षांचा<br />अनुभव",
  MissionVission: "आमचे ध्येय <br /> आणि दृष्टी",
  ourHistory: "आमचा इतिहास",
  ChairmanDesk: "अध्यक्षांच्या डेस्कवरून",
  //NetworkPage 
  PartnerHead: "आमचे भागीदार",
  DealerHead: "आमचा डीलर होऊ इच्छिता?",
  DealerBtn: "आमच्याशी कनेक्ट व्हा",
  //Form Field
  FormHead: "काही प्रश्न आहेत का? संपर्क साधा!",
  FirstName: "पहिले नाव",
  LastName: "आडनाव",
  PhoneNo: "फोन नंबर",
  Email: "ईमेल",
  Message: "संदेश",
  SubmitButton: "सबमिट करा",
  FullName: "पूर्ण नाव",
  Address: "पत्ता",
  City: "शहर",
  PinCode: "पिनकोड",
  
  //Contact page
  Call: "आम्हाला कॉल करा",
  Mail: "आम्हाला मेल करा",
  loc: "स्थान",
  HaveEnquiries: "चौकशी आहेत?",
  //Product
  Description: "वर्णन",
  Specifications: "तपशील",
  EnquireNowButton: "आता चौकशी करा",
  ViewSpecificationsButton: "तपशील पहा",
  //Product Details Page
  MRP: "एमआरपी",
  Weight: "वजन",
  Quantity: "प्रमाण",
  OutOfStock: "स्टॉक संपला",
  Description: "वर्णन",
  AddToCart: "कार्टमध्ये जोडा",
  EnquiryNowButton: "आता चौकशी करा",
  RelatedProducts: "संबंधित उत्पादने",
  OthersCategory: "इतर श्रेणी",
  //Store Page
  Filters: "फिल्टर",
  Category: "श्रेणी",
  LoadMore: "अधिक लोड करा",
  NoProductsFound: "दाखवण्यासाठी कोणतेही उत्पादन आढळले नाही.",
  //Cart Page
  Cart: "कार्ट",
  Checkout: "चेकआउट",
  Payment: "पेमेंट",
  Price: "किंमत",
  Total: "एकूण",
  Code: "कोड",
  DeliveryCharges: "वितरण शुल्क",
  DeliveryChargesNote: "जर एकूण रक्कम ७०० पेक्षा कमी असेल तर तुम्हाला डिलिव्हरी शुल्क भरावे लागेल.",
  Subtotal: "बेरजे",
  ContinueShoppingButton: "खरेदी सुरू ठेवा",
  CheckoutButton: "चेकआउट",
  YourCartIsEmpty: "तुमची कार्ट रिकामी आहे",
  //Checkout Page
  AddAddress: "पत्ता जोडा",
  Close: "बंद करा",
  PleaseLoginToCheckout: "चेकआउट करण्यासाठी कृपया लॉगिन करा.",
  LoginHere: "येथे लॉगिन करा",
  PayNow: "आता पैसे द्या",
  OrderSummery: "ऑर्डर सारांश",
  Note: "नोंद",
  DoNotRefreshOrClose: "चालू असलेल्या व्यवहारादरम्यान हे पेज रिफ्रेश करू नका किंवा बंद करू नका. असे केल्याने डुप्लिकेट शुल्क आकारले जाऊ शकते किंवा व्यवहार अयशस्वी होऊ शकतो.",
  AddYourAddressDetails: "तुमचा पत्ता तपशील जोडा",
  //Footer
  FeelFreeToCallUs: "आम्हाला कॉल करण्यास मोकळ्या मनाने",
  OfficeLocation: "कार्यालयाचे स्थान",
  DropUsAnEmail: "आम्हाला ईमेल टाका",
  ConnectWithUs: "आमच्याशी कनेक्ट व्हा",
  //Dashboard Page
  MyOrders: "माझे आदेश",
  Wishlist: "विशलिस्ट",
  MyAccount: "माझे खाते",
  Logout: "लॉगआउट करा",
  ViewOrder: "ऑर्डर पहा",
  ID: "ऑर्डर आयडी",
  Date: "तारीख",
  Total: "एकूण",
  Status: "स्थिती",
  ViewOrder: "ऑर्डर पहा",
  DownloadInvoice: "बीजक डाउनलोड करा",
  OrderReceived: "ऑर्डर मिळाली",
  OrderProcessing: "ऑर्डर प्रक्रिया",
  OrderDispatch: "ऑर्डर डिस्पॅच",
  OrderDeliver: "ऑर्डर वितरित करा",
  Paymentprocessing: "पेमेंट प्रक्रिया",
  Unknownstatus: "अज्ञात स्थिती",
  SlNo: "क्र. क्र",
  Item: "आयटम",
  image: "प्रतिमा",
  //logout  
  AreYouSure: "तुम्हाला खात्री आहे का?",
  Logout: "लॉगआउट करा!",
  Cancel: "रद्द करा",
  //SEO
  Best: "सर्वोत्तम",
  BuyNowButton: "आता खरेदी करा",
};

export default mr;